import React from 'react';
import BasicCard from '../../pages/BasicCard';
import MainLayout from '../../pages/MainLayout';
import SkillsForms from '../../pages/Skills/Skillsform';
import Dummylayout from '../../pages/Dummylayout';
import Topbar from '../Topbar';
import Sidemenu from '../Sidemenu';
import Filter from '../Filter';
import BootTable from '../../pages/Skills/BootTable';
function SkillsTable(){
  
  return(
    <>

   <Dummylayout/>
    <BasicCard>
    <div className='row border-1'>
      <div className='col-lg-6'>
        <h4 className="text-start pb-3">Skills</h4>
      </div>
      <div className='col-lg-6 text-end bg-white '>
      <a href='SkillsForms' className="text-decoration-none text-white" ><button type="button" class="btn btn-danger rounded-pill">Add Skills</button></a>
      </div>
     
      </div>
      <BootTable/>
    {/* <div className='container-fluid'>
     
      <div className='row'>
      <div className='col-lg-6'>
        <h4 className="text-start pb-3">Skills</h4>
      </div>
      <div className='col-lg-6 text-end bg-white '>
      <a href='SkillsForms' className="text-decoration-none text-white" ><button type="button" class="btn btn-danger rounded-pill">Add Skills</button></a>
      </div>
      </div>

      <table id="example" class="table table-striped w-100">
        <thead>
            <tr>
                <th>#</th>
               
                <th>Skill</th>
                <th>Skill Level</th>
                <th>Progress</th>
                <th>Justification</th>
                <th className='pl-4'>Action</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>1</td>
                <td>Communication</td>
                <td>Intermediate </td>
              
               
                <td>
                <div class="progress mt-1">
        <div class="progress-bar bg-success" role="progressbar"  aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
  </div>


                </td>
                <td>Lorem Ipsum is simply...</td>
                <td>
                  <div className='row p-0'>

                <div className='col-sm-2'>
                            
           
               
              
                </div>


                <div className='col-sm-2'>
                <svg  data-bs-toggle="modal" data-bs-target="#exampleModalview" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                   <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
                  <div class="modal fade" id="exampleModalview" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                     <div class="modal-dialog modal-dialog-centered ">
                         <div class="modal-content w-75 m-auto Small shadow">
                              <div class="modal-header border-bottom-0"> 
                              <h5 class="modal-title text-center" id="exampleModalLabel">Goal Details</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body p-3 ml-3 mr-3 pl-3 border rounded ">
                              
                            <p class="modal-title text-start h5" id="exampleModalLabel">Task Name</p>
                            <p className='text-secondary pt-2 small'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                            <hr className='border'></hr>
                           
                            <div className='row'>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Department :</p>
                              <p className="listp ml-1">HR Department</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Assingee :</p>
                              <label className='pl-1'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                                    <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
                                  </svg>
                              </label>
                              <p className="listp ml-1 font-weight-medium">Gladwin</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Status :</p>
                              <p className="listp ml-1 text-success font-weight-bold rounded bg-light pl-1 pr-1">Completed</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Start Date :</p>
                              <p className="listp ml-1">04-12-2023</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Due Date :</p>
                              <p className="listp ml-1">04-12-2024</p>
                              </div>
                            </div>

                            
                
                            </div>
                            <div class="modal-footer text-center border-top-0">
                         
                            </div>
                      </div>
                    </div>
                </div>
               
                </div>



                <div className='col-sm-2'>
                <a cursor-pointer href='goalsform'className="text-decoration-none text-black"><svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                 <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
               <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
              </svg></a>
              </div>

              </div>
                </td>
            </tr>
        
         <tr>
                <td>2</td>
                <td>New technology</td>
                <td>Begginer </td>
              
               
                <td>
                <div class="progress mt-1">
        <div class="progress-bar bg-success" role="progressbar"  aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
  </div>


                </td>
                <td>Lorem Ipsum is simply...</td>
                <td>
                  <div className='row p-0'>

                <div className='col-sm-2'>
                            
               
               
               
              
                </div>


                <div className='col-sm-2'>
                <svg  data-bs-toggle="modal" data-bs-target="#exampleModalview" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                   <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
                  <div class="modal fade" id="exampleModalview" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                     <div class="modal-dialog modal-dialog-centered ">
                         <div class="modal-content w-75 m-auto Small shadow">
                              <div class="modal-header border-bottom-0"> 
                              <h5 class="modal-title text-center" id="exampleModalLabel">Goal Details</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body p-3 ml-3 mr-3 pl-3 border rounded ">
                              
                            <p class="modal-title text-start h5" id="exampleModalLabel">Task Name</p>
                            <p className='text-secondary pt-2 small'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                            <hr className='border'></hr>
                           
                            <div className='row'>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Department :</p>
                              <p className="listp ml-1">HR Department</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Assingee :</p>
                              <label className='pl-1'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                                    <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
                                  </svg>
                              </label>
                              <p className="listp ml-1 font-weight-medium">Gladwin</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Status :</p>
                              <p className="listp ml-1 text-success font-weight-bold rounded bg-light pl-1 pr-1">Completed</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Start Date :</p>
                              <p className="listp ml-1">04-12-2023</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Due Date :</p>
                              <p className="listp ml-1">04-12-2024</p>
                              </div>
                            </div>

                            
                
                            </div>
                            <div class="modal-footer text-center border-top-0">
                            </div>
                      </div>
                    </div>
                </div>
               
                </div>



                <div className='col-sm-2'>
                <a cursor-pointer href='goalsform'className="text-decoration-none text-black"><svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                 <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
               <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
              </svg></a>
              </div>

              </div>
                </td>
            </tr>

 
  <tr>
                <td>3</td>
                <td>Skill 3</td>
                <td>Advanced </td>
              
               
                <td>
                <div class="progress mt-1">
        <div class="progress-bar bg-success" role="progressbar"  aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
  </div>


                </td>
                <td>Lorem Ipsum is simply...</td>
                <td>
                  <div className='row p-0'>

                <div className='col-sm-2'>
                            
               
               
               
              
                </div>


                <div className='col-sm-2'>
                <svg  data-bs-toggle="modal" data-bs-target="#exampleModalview" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                   <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
                  <div class="modal fade" id="exampleModalview" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                     <div class="modal-dialog modal-dialog-centered ">
                         <div class="modal-content w-75 m-auto Small shadow">
                              <div class="modal-header border-bottom-0"> 
                              <h5 class="modal-title text-center" id="exampleModalLabel">Goal Details</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body p-3 ml-3 mr-3 pl-3 border rounded ">
                              
                            <p class="modal-title text-start h5" id="exampleModalLabel">Task Name</p>
                            <p className='text-secondary pt-2 small'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                            <hr className='border'></hr>
                           
                            <div className='row'>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Department :</p>
                              <p className="listp ml-1">HR Department</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Assingee :</p>
                              <label className='pl-1'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                                    <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
                                  </svg>
                              </label>
                              <p className="listp ml-1 font-weight-medium">Gladwin</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Status :</p>
                              <p className="listp ml-1 text-success font-weight-bold rounded bg-light pl-1 pr-1">Completed</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Start Date :</p>
                              <p className="listp ml-1">04-12-2023</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Due Date :</p>
                              <p className="listp ml-1">04-12-2024</p>
                              </div>
                            </div>

                            
                
                            </div>
                            <div class="modal-footer text-center border-top-0">
                            </div>
                      </div>
                    </div>
                </div>
               
                </div>



                <div className='col-sm-2'>
                <a cursor-pointer href='goalsform'className="text-decoration-none text-black"><svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                 <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
               <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
              </svg></a>
              </div>

              </div>
                </td>
            </tr>
          
            <tr>
                <td>4</td>
                <td>Skill 4</td>
                <td>Begginer </td>
              
               
                <td>
                <div class="progress mt-1">
        <div class="progress-bar bg-success" role="progressbar"  aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
  </div>


                </td>
                <td>Lorem Ipsum is simply...</td>
                <td>
                  <div className='row p-0'>

                <div className='col-sm-2'>
                            
             
               
               
              
                </div>


                <div className='col-sm-2'>
                <svg  data-bs-toggle="modal" data-bs-target="#exampleModalview" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                   <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
                  <div class="modal fade" id="exampleModalview" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                     <div class="modal-dialog modal-dialog-centered ">
                         <div class="modal-content w-75 m-auto Small shadow">
                              <div class="modal-header border-bottom-0"> 
                              <h5 class="modal-title text-center" id="exampleModalLabel">Goal Details</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body p-3 ml-3 mr-3 pl-3 border rounded ">
                              
                            <p class="modal-title text-start h5" id="exampleModalLabel">Task Name</p>
                            <p className='text-secondary pt-2 small'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                            <hr className='border'></hr>
                           
                            <div className='row'>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Department :</p>
                              <p className="listp ml-1">HR Department</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Assingee :</p>
                              <label className='pl-1'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                                    <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
                                  </svg>
                              </label>
                              <p className="listp ml-1 font-weight-medium">Gladwin</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Status :</p>
                              <p className="listp ml-1 text-success font-weight-bold rounded bg-light pl-1 pr-1">Completed</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Start Date :</p>
                              <p className="listp ml-1">04-12-2023</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Due Date :</p>
                              <p className="listp ml-1">04-12-2024</p>
                              </div>
                            </div>

                            
                
                            </div>
                            <div class="modal-footer text-center border-top-0">
                            </div>
                      </div>
                    </div>
                </div>
               
                </div>



                <div className='col-sm-2'>
                <a cursor-pointer href='goalsform'className="text-decoration-none text-black"><svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                 <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
               <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
              </svg></a>
              </div>

              </div>
                </td>
            </tr>



         
            <tr>
                <td>5</td>
                <td>Skill 5</td>
                <td>Intermediate </td>
              
               
                <td>
                <div class="progress mt-1">
        <div class="progress-bar bg-success" role="progressbar"  aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
          </div>


                </td>
                <td>Lorem Ipsum is simply...</td>
                <td>
                  <div className='row p-0'>

                <div className='col-sm-2'>
                            
             
               
               
              
                </div>


                <div className='col-sm-2'>
                <svg  data-bs-toggle="modal" data-bs-target="#exampleModalview" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                   <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                </svg>
                  <div class="modal fade" id="exampleModalview" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                     <div class="modal-dialog modal-dialog-centered ">
                         <div class="modal-content w-75 m-auto Small shadow">
                              <div class="modal-header border-bottom-0"> 
                              <h5 class="modal-title text-center" id="exampleModalLabel">Goal Details</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body p-3 ml-3 mr-3 pl-3 border rounded ">
                              
                            <p class="modal-title text-start h5" id="exampleModalLabel">Task Name</p>
                            <p className='text-secondary pt-2 small'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                            <hr className='border'></hr>
                           
                            <div className='row'>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Department :</p>
                              <p className="listp ml-1">HR Department</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Assingee :</p>
                              <label className='pl-1'>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                                    <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
                                  </svg>
                              </label>
                              <p className="listp ml-1 font-weight-medium">Gladwin</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Status :</p>
                              <p className="listp ml-1 text-success font-weight-bold rounded bg-light pl-1 pr-1">Completed</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Start Date :</p>
                              <p className="listp ml-1">04-12-2023</p>
                              </div>
                              <div className='col-lg-12 d-flex'>
                              <p className='listtitle'>Due Date :</p>
                              <p className="listp ml-1">04-12-2024</p>
                              </div>
                            </div>

                            
                
                            </div>
                            <div class="modal-footer text-center border-top-0">
                            </div>
                      </div>
                    </div>
                </div>
               
                </div>



                <div className='col-sm-2'>
                <a cursor-pointer href='goalsform'className="text-decoration-none text-black"><svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                 <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
               <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
              </svg></a>
              </div>

              </div>
                </td>
            </tr>
        
        
            

        </tbody>
        <tfoot>
           
        </tfoot>
    </table>
    </div> */}
    </BasicCard>
    </>
  );
}
export default SkillsTable;


